//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false, _: false */

(function() {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsProductizeCatalogSelector', [
    '$q',
    '$rootScope',
    'SyndicationService',
    'UniversalImageActionsService',
    function(
            $q,
            $rootScope,
            SyndicationService,
            UniversalImageActionsService,
        ) {
      return {
        restrict: 'E',
        scope: {
          creatorClientId: '@',
          catalogSelectedCallback: '&',
          catalogSelectorLoadedCallback: '&',
        },
        require: '^universalImageActionsProductize',
        template: require('@legacy-components/common/universal-image-actions/universal-image-actions-productize-catalog-selector.html'),
        link(scope) {
          const launchOptions = UniversalImageActionsService.getCurrentLaunchOptions();

          scope.model = {
            catalogClients: [],
            loading: true,
          };

          scope.$watch('model.selectedCatalogClient', (newVal, oldVal) => {
            if (!angular.equals(newVal, oldVal)) {
              scope.catalogSelectedCallback({ catalogClient: newVal });
            }
          });

                    //
                    // Initialization
                    //
          SyndicationService.getProductCatalogClients(launchOptions.getItemId()).then((catalogClients) => {
            scope.model.catalogClients = catalogClients;

            if (catalogClients.length === 1) {
                            // If only one client has a product catalog configured, select this catalog rather than always
                            // defaulting to the publisher catalog. This is useful for the "brand pushing approved content to store accounts"
                            // scenario. Likely the HQ account has a catalog configured and is sharing content with store accounts, but
                            // the store accounts are the "publisher" in this case.
              scope.catalogSelectedCallback({ catalogClient: catalogClients[0] });
            }
          }).finally(() => {
            scope.model.loading = false;
            scope.catalogSelectorLoadedCallback();
          });
        },
      };
    },
  ]);
})();
